import { useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useGetTutorialVideosQuery } from 'shared/api/containerApi'
import { TutorialConfig } from 'shared/components/MainLayout/components/TutorialModal/TutorialModal.types'
import { pickLocalizedText } from 'shared/utils'

import { useActiveApp } from './useActiveApp'

export const useTutorialButton = () => {
  const activeApp = useActiveApp()
  const { i18n } = useTranslation()
  const { data: videos } = useGetTutorialVideosQuery(activeApp?.app.id)

  const [isOpen, setIsOpen] = useState(false)

  const configs: TutorialConfig[] = useMemo(
    () =>
      (videos ?? []).map(video => ({
        id: video.id,
        title: pickLocalizedText(video.title, i18n.language),
        videoUrl: video.video_url,
        chapters: [...video.chapters]
          .sort((a, b) => a.start_seconds - b.start_seconds)
          .map(chapter => ({
            id: chapter.id,
            title: pickLocalizedText(chapter.name, i18n.language),
            timestamp: chapter.start_seconds
          }))
      })),
    [i18n.language, videos]
  )

  return {
    configs,
    isOpen,
    open: () => setIsOpen(true),
    close: () => setIsOpen(false)
  }
}
